import { useContext, useState } from 'react';
import { Box, Grid, TextField } from '@mui/material';
import { Save } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { SttButton } from '../../../sporttia/buttons/SttButton';
import { AppContext } from '../../../sporttia/all';
import { useCanModifyConfiguration } from './useCanModifyConfiguration';

export default function ConfigurationCashdro(): React.ReactElement {
    const [ip, setIp] = useState<string | null>(
        localStorage.getItem('CashdroIp'),
    );
    const [user, setUser] = useState<string | null>(
        localStorage.getItem('CashdroUser'),
    );
    const [pass, setPass] = useState<string | null>(
        localStorage.getItem('CashdroPass'),
    );

    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const canModify = useCanModifyConfiguration();

    function setIpValue(value: string): void {
        setIp(value);
    }

    function setUserValue(value: string): void {
        setUser(value);
    }

    function setPassValue(value: string): void {
        setPass(value);
    }

    function save(): void {
        cxt?.showMessage('S', t('Saved'));
        localStorage.setItem('CashdroIp', ip || '');
        localStorage.setItem('CashdroUser', user || '');
        localStorage.setItem('CashdroPass', pass || '');
    }

    return (
        <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    label={t('cashdro.ipDevice')}
                    size="small"
                    disabled={!canModify}
                    value={ip || ''}
                    onChange={(e: any) => {
                        setIpValue(e.target.value);
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Box>{t('cashdro.ipHelper')}</Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    label={t('cashdro.username')}
                    size="small"
                    disabled={!canModify}
                    value={user || ''}
                    onChange={(e: any) => {
                        setUserValue(e.target.value);
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    label={t('cashdro.passwordField')}
                    size="small"
                    disabled={!canModify}
                    value={pass || ''}
                    onChange={(e: any) => {
                        setPassValue(e.target.value);
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Box>{t('cashdro.credentialsHelper')}</Box>
            </Grid>
            {canModify && (
                <Grid size={{ xs: 12, sm: 6 }}>
                    <SttButton
                        startIcon={<Save />}
                        caption={t('Save')}
                        color="primary"
                        variant="contained"
                        onClick={() => {
                            save();
                        }}
                    />
                </Grid>
            )}
        </Grid>
    );
}
